<template>
  <div class="rating-stars" :style="`color: ${color};`">
    <v-icon
      :size="size"
      :left="true"
      v-for="(star, index) in filledStars"
      :key="'filled-' + index"
    >
      bhi-star-filled
    </v-icon>
    <v-icon
      :size="size"
      :left="true"
      v-for="(star, index) in emptyStars"
      :key="'empty-' + index"
    >
      bhi-star-empty
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'RatingStars',
  components: {},
  props: {
    color: {
      type: String,
      default: 'var(--bh-blue)',
    },
    stars: {
      type: Number,
      default: 5,
    },
    rating: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 18,
    },
  },
  computed: {
    computedRating() {
      let rating = 0
      if (this.stars && this.rating) {
        rating = Math.round(this.rating)
        if (rating > this.stars) rating = this.stars
      }
      return rating
    },
    filledStars() {
      let arr = []
      if (this.stars && this.computedRating) {
        arr = Array.from({ length: this.computedRating }, (v, k) => k + 1)
      }
      return arr
    },
    emptyStars() {
      let arr = []
      let count = parseInt(this.stars) - parseInt(this.filledStars.length)
      if (this.stars) arr = Array.from({ length: count }, (v, k) => k + 1)
      return arr
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.rating-stars {
  display: flex;
  .v-icon {
    color: currentColor;
  }
}
</style>
